module.exports = __webpack_public_path__ + "img/landliebe-6361.36c2fc6f.jpeg";